import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

export const router: Routes = [
  {
    path: '',
    redirectTo: 'booking-process/disclaimer',
    pathMatch: 'full'
  },
  {
    path: 'booking-process',
    loadChildren: () =>
      import('./booking-process/booking-process.module').then(m => m.BookingProcessModule)
  },
  {
    path: 'cc-avenue',
    loadChildren: () =>
      import('./cc-avenue/cc-avenue.module').then(m => m.CcAvenueModule)
  },
  {
    path: 'thank-you',
    loadChildren: () =>
      import('./thank-you/thank-you.module').then(m => m.ThankYouModule)
  },
  {
    path: 'sorry',
    loadChildren: () =>
      import('./sorry/sorry.module').then(m => m.SorryModule)
  },
  {
    path: '**',
    redirectTo: 'booking-process/disclaimer',
    pathMatch: 'full'
  }
];

// ✅ Must include the generic type for Angular 9+
export const appRouter: ModuleWithProviders<RouterModule> = RouterModule.forRoot(router);
